/*
  CTA « Besoin d'aide ? » des tiroirs de filtres et de panier.

  Shopify ne documente aucune API pour ouvrir le chat Inbox depuis la vitrine :
  `#shopify-element-wrapper` et ses classes ne sont pas un contrat public. On relaie donc
  le clic au lanceur natif, et on retombe sur la page contact si le conteneur a disparu —
  plutôt que de laisser un bouton muet.
*/

const HELP_FALLBACK_URL = '/pages/contact';

function closeDrawer(cta) {
  const cartDrawer = cta.closest('cart-drawer');
  if (cartDrawer) {
    cartDrawer.close();
    return;
  }

  // Tiroir de filtres : même geste que le bouton « Appliquer » de Dawn.
  cta.closest('.mobile-facets__wrapper')?.querySelector('summary')?.click();
}

function openNativeChat() {
  const wrapper = document.querySelector('#shopify-element-wrapper');
  if (!wrapper) {
    window.location.assign(HELP_FALLBACK_URL);
    return;
  }

  const launcher =
    wrapper.querySelector('button, [role="button"], a') || wrapper.querySelector('[class*="activator"]');

  (launcher || wrapper).click();
}

document.addEventListener('click', (event) => {
  const cta = event.target.closest('[data-bdr-help]');
  if (!cta) return;

  closeDrawer(cta);

  // Le lanceur ne redevient visible qu'au retrait de la classe posée sur <body> :
  // on attend la frame suivante pour ne pas cliquer un élément encore masqué.
  requestAnimationFrame(openNativeChat);
});
